import * as React from 'react'
import MUIAutocomplete from '@mui/material/Autocomplete'

const Autocomplete = (props) => <MUIAutocomplete {...props} />

export default Autocomplete
